import React, { useState } from "react";
import styles from './ReportFilterMonthlySummary.module.scss';
import { Badge, Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { t } from "i18next";
import Lottie from "react-lottie";
import reportTicket from "../../../assets/animation/animation_report";
import DatePicker from "react-datepicker";
import it from 'date-fns/locale/it';


//general
import UserClass from "../../../General/LocalStorage/UserClass";
import DataManager from "../../../General/DataManager";
import Functions from "../../../General/Functions";



const ReportFilterMonthlySummary = props => {

    const defaultOptionsReport = {
        loop: true,
        autoplay: true,
        animationData: reportTicket
    };
    const [company, setCompany] = useState("");
    const [showModalFilter, setShowModalFilter] = useState(false);
    const [showModalFilterMonthlySummary, setshowModalFilterMonthlySummary] = useState(false);
    const [msgModalReport, setMsgModalReport] = useState("");
    const [pdfChecked, setpdfChecked] = useState(true);
    const [csvChecked, setcsvChecked] = useState(false);
    const [dateFrom, setDateFrom] = useState(null);
    const [companies, setCompanies] = useState([])
    const [showModalFilterRaceSummary, setshowModalFilterRaceSummary] = useState(false);
    const [typologyReport, setTypologyReport] = useState("");
    const [dateOfDay, setDateOfDay] = useState("");
    const [dateOfMonth, setDateOfMonth] = useState(null);
    const [reset, setReset] = useState(false);
    const [Document, setDocument] = useState(null)
    const [showCompany, setshowCompany] = useState(true)
    const [disableButton, setDisableButton] = useState(true)

    const [showDocument, setshowDocument] = useState(true)

    const [totFilter, setTotFilter] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState('DEPARTUREDATE');




    React.useEffect(() => {

        getCompanies();
    }, []);

    const actionSelectFilter = () => {
        /*if (arrFilter !== null){
             setDateOfDay(arrFilter.dateOfDay);
             setTypologyReport(arrFilter.typologyReport);
             setDateOfMonth(arrFilter.dateOfMonth);
             setReset(false);
         }*/
        setShowModalFilter(!showModalFilter);
    };
    const renderOption2 = (obj, idx) => {
        let check = false;
        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            if (company.toString() === obj) {
                check = true;
            }
        }
        return <option selected={check} key={idx}>{t(obj)}</option>
    };

    const setTypeCompany = (e) => {
        let selectedIndex = e.target.selectedIndex;
        let selectedOption = e.target.options[selectedIndex];
        let selectedValue = selectedOption.value;

        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {
                setCompany(companies[e.target.selectedIndex - 1]);
                if (companies[e.target.selectedIndex - 1] !== "" && companies[e.target.selectedIndex - 1] !== undefined) {
                    setDisableButton(false)
                }
                else {
                    setDisableButton(true)

                }


            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();

    };



    const handleChange = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    const actionReset = () => {
        setReset(true);
        setCompany("")
        setDateFrom("")
        setpdfChecked(true)
        setcsvChecked(false)
        setDateOfMonth(null)
        setDisableButton(true)
        setshowCompany(true)
        setshowDocument(true);
        setTotFilter(0)
        setSelectedFilter('DEPARTUREDATE');


    };

    const ConvertDate = (str) => {
        let date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");

    }
    const actionApply = () => {
        let tot = 0;
        setTotFilter(tot);

        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            setShowModalFilter(false)
            setshowModalFilterMonthlySummary(true)
            setDocument(null)

            let modeFile = "pdf";
            if (csvChecked == true) {
                modeFile = "csv";
            }
            let instance = UserClass.getInstance();

            let token = instance.getTokenUser();
            let date_from = dateOfMonth;

            let dateFinal = Functions.convertDateToString(dateOfMonth, "YYYY-MM");
            let lastDayOfMonth = new Date(dateFinal.split("-")[0], dateFinal.split("-")[1], 0);
            lastDayOfMonth = ConvertDate(lastDayOfMonth.toString())
            date_from = ConvertDate(date_from.toString());




            DataManager.getReportMonthlySummary(token, modeFile, date_from, lastDayOfMonth, company, selectedFilter).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['report']) !== 'undefined' && result['report'] !== null) {
                        if (modeFile.toString() === "csv") {
                            const url = window.URL.createObjectURL(new Blob([result['report']]))
                            const link = document.createElement('a')
                            link.href = url;
                            const fileName = `report.csv`;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            setshowModalFilterMonthlySummary(false)
                        } else {
                            let blob = new Blob([result['report']], {
                                type: "application/pdf"
                            });
                            const url = window.URL.createObjectURL(blob);
                            setDocument(url);
                            setshowDocument(false)
                            setshowModalFilterMonthlySummary(false)
                        }

                    } else {
                        setshowModalFilterMonthlySummary(false)

                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {

                    setshowModalFilterMonthlySummary(false)
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            })



            setshowModalFilterRaceSummary(false)


            if (company !== "") {
                tot = tot + 1;

            }
            if (csvChecked || pdfChecked) {
                tot = tot + 1;
            }

            if (dateOfMonth != "") {
                tot = tot + 1;
            }

            if (selectedFilter) {
                tot = tot + 1;
            }



            setTotFilter(tot)




        }
        else {
            Functions.alertMsg("Company Field is required");

        }
    };


    const getCompanies = () => {
        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();


        DataManager.verifyLogin
            (token).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['verifylogin']) !== 'undefined' && result['verifylogin'] !== null) {

                        setCompanies(result['verifylogin']['companies'])
                    } else {
                        setshowModalFilterRaceSummary(false);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    setshowModalFilterRaceSummary(false);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            });
    }

    return (
        <div className={styles.ReportFilterDailySummary}>
            <Button
                className="mb-3 ml-10"
                onClick={actionSelectFilter}
                title={t("filters")}
            >
                <i className="fa-solid fa-filter side-menu__icon" /> {t("filters")} {totFilter > 0 ? <Badge bg="secondary">{totFilter.toString()}</Badge> : null}
            </Button>
            <Modal
                {...props}
                size="xs"
                show={showModalFilterMonthlySummary}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>{msgModalReport}</Modal.Body>
                <Lottie options={defaultOptionsReport}
                    height={200} />
            </Modal>
            <Modal show={showModalFilter}>
                <Modal.Header>
                    <Modal.Title>{t("filters")}</Modal.Title>
                    <Button onClick={actionSelectFilter}><i className="fa-solid fa-xmark" /></Button>
                </Modal.Header>
                <Modal.Body style={{
                    maxHeight: 'calc(100vh - 210px)',
                    overflowY: 'auto'
                }}>
                    <Form>
                        <Form.Label>{t("file_format")}</Form.Label>
                        <Row>
                            <Col xl={6}>
                                <Form.Group className="mb-3">

                                    <div className="mb-3">
                                        <Form.Check
                                            value="daily"
                                            type="radio"
                                            aria-label="radio 1"
                                            label={"PDF"}
                                            checked={pdfChecked}

                                            onChange={(e) => {
                                                setpdfChecked(true);
                                                setcsvChecked(false);

                                            }}
                                        />

                                    </div>
                                </Form.Group>
                            </Col>
                            <Col xl={6}>
                                <Form.Group className="mb-3">
                                    <div className="mb-3">
                                        <Form.Check
                                            value="monthly"
                                            type="radio"
                                            aria-label="radio 2"
                                            label={"CSV"}
                                            checked={csvChecked}
                                            onChange={(e) => {
                                                setpdfChecked(false);
                                                setcsvChecked(true);

                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                        <>
                            <Form.Label>{t("select_filter_type")}</Form.Label>
                            <Row>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("departure_date")}
                                            value="DEPARTUREDATE"
                                            checked={selectedFilter === 'DEPARTUREDATE'}
                                            onChange={() => setSelectedFilter('DEPARTUREDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("issue_date")}
                                            value="ISSUEDATE"
                                            checked={selectedFilter === 'ISSUEDATE'}
                                            onChange={() => setSelectedFilter('ISSUEDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("boarding_date")}
                                            value="BOARDINGDATE"
                                            checked={selectedFilter === 'BOARDINGDATE'}
                                            onChange={() => setSelectedFilter('BOARDINGDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                    </Form>



                </Modal.Body>

                <Form style={{
                    marginLeft: '15px',
                    marginBottom: '10px',
                    marginTop: '-10px'
                }}>
                    <Row>
                        <Col xl={12}>
                            <p>{t("select_month_year")}</p>
                            <DatePicker locale={it}
                                selected={dateOfMonth !== null ? dateOfMonth : ""}
                                onChange={(date) => {
                                    setDateOfMonth(date);
                                    setshowCompany(false);

                                }}
                                placeholderText={"mm/aaaa"}

                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                                showFullMonthYearPicker
                                showTwoColumnMonthYearPicker />
                        </Col>
                    </Row>
                    <Row hidden={showCompany}>
                        <Col xl={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("company")}</Form.Label>
                                <Form.Select size="lg" onChange={(e) => setTypeCompany(e)}>
                                    <option key="value_null">-- {t("select")} --</option>
                                    {companies.map((item, idx) => (
                                        renderOption2(item, idx)
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>

                <Modal.Footer>

                    <Button variant="secondary" onClick={actionReset}>
                        {t("reset")}
                    </Button>
                    <Button disabled={disableButton} variant="primary" onClick={actionApply}>
                        {t("apply")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Row hidden={showDocument}>

                {

                    Document !== null ?
                        (

                            <Col xl={12}>
                                <div className="pb-70">
                                    <Card>
                                        <Card.Body>
                                            <object width="100%" height="600"
                                                data={Document}
                                                type="application/pdf"></object>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>


                        )
                        : null
                }
            </Row>
        </div>
    )
};

export default ReportFilterMonthlySummary;
